import { EventPlatformPlaylist } from "./PlaylistCarousels";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { baseUrl, translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { Config, useConfig } from "@kaltura/mediaspace-shared-data-kms-config";
import { ChannelPlaylistsDisplayType } from "@kaltura/mediaspace-shared-types";
import { isDisplayingPlaylistComponent, SinglePlaylist } from "@kaltura/mediaspace-shared-ui";
import styled from "@emotion/styled";

export interface PlaylistsListProps {
    data?: EventPlatformPlaylist[];
    categoryId?: number;
}

const StyledCarousel = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(2),
    },
}));

/**
 * Component to render a list of playlists carousels
 */
export const PlaylistsList = ({ data, categoryId }: PlaylistsListProps) => {
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
    const config: Config = useConfig();
    const channelPlaylistsDisplay = config?.channelPlaylists?.playlistDisplay;

    const getPlaylistUrl = (id: string) => {
        return channelPlaylistsDisplay === ChannelPlaylistsDisplayType.player
            ? `${baseUrl}/playlist/dedicated/${categoryId ? categoryId + "/" : ""}${id}`
            : `${baseUrl}/playlist/${id}${categoryId ? "/" + categoryId : ""}`;
    };

    return (
        <>
            {data?.map(({ entries, id, name, titleAreaButtons }) => {
                if (!isDisplayingPlaylistComponent(entries, titleAreaButtons)) {
                    return null;
                }
                return (
                    <StyledCarousel key={id}>
                        <SinglePlaylist
                            entries={entries}
                            playlistId={id}
                            categoryId={categoryId}
                            translatedTitle={name}
                            titleLink={getPlaylistUrl(id)}
                            translatedLinkString={translate("See All")}
                            fullScreenWidth={isSmScreen}
                            titleAreaButtons={titleAreaButtons}
                        />
                    </StyledCarousel>
                );
            })}
        </>
    );
};
